import React, { useEffect } from "react";
import moment from "moment";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Datetime from "react-datetime";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import styles from "../../../assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";

import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { useDispatch, useSelector } from "react-redux";
import {
  getAnzsco,
  getDropDown,
  getOccupation,
  isDuplicateApplicant,
  isValidTribunalReviewInputs,
  labelStyleFunc,
} from "../../../scripts/util";
import {
  CLEAR_ERROR,
  TRIBUNAL_REVIEW_GET_ALL_REQUESTED,
  TRIBUNAL_REVIEW_CREATE_REQUESTED,
} from "../../../redux/actions";
import SnackbarContent from "../../../components/Snackbar/SnackbarContent";
import ReactGA from "react-ga4";
import {
  DEFAULT_DATE_FORMAT,
  GENERAL_ROLE,
  occupationCodeOption,
  useGetOccupationOptions,
  useGetVisaTypeOptions,
  TINY_INIT,
} from "../../../scripts/const";
import CustomLinearProgress from "../../../components/CustomLinearProgress/CustomLinearProgress";
import ConfirmationAlert from "../../../components/Alert/ConfirmationAlert";
import { Editor } from "@tinymce/tinymce-react";
import { default as ReactSelect } from "react-select";
import FileUpload from "../../../components/CustomUpload/FileUpload";
import DropDownWithSearch, {
  customReactSelectStyles,
} from "../../../components/DropDownWithSearch/DropDownWithSearch";

const useStyles = makeStyles(styles);

export default function AddTribunalReview(props) {
  const { roleId: currentRoleId } = useSelector(
    (state) => state.login.loginUser.detail
  );
  const occupationOption = useGetOccupationOptions();
  const visaTypeOption = useGetVisaTypeOptions();

  const isGeneralUser = GENERAL_ROLE.includes(currentRoleId);
  const [alert, setAlert] = React.useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  const submit = () => {
    confirmTribunalReview();
  };
  const selectedEvent = () => {
    setAlert(<ConfirmationAlert cancel={hideAlert} submit={submit} />);
  };

  const [validationErrorMsg, setValidationErrorMsg] = React.useState(null);
  const [error, setError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const [modalOpen, setModalOpen] = React.useState(false);
  const [tribunalReview, setTribunalReview] = React.useState({});
  const [errMessage, setErrorMsg] = React.useState(
    "Something went wrong. Please try again."
  );
  const errMsg = useSelector((state) => state.tribunalReview.errorMsg);
  useEffect(() => {
    setErrorMsg(errMsg);
  }, [errMsg]);

  const handleFileUpload = (fileUrl) => {
    if (!tribunalReview.files) {
      setTribunalReview({
        ...tribunalReview,
        files: [fileUrl],
      });
    } else {
      setTribunalReview({
        ...tribunalReview,
        files: [...tribunalReview.files, fileUrl],
      });
    }
  };

  const handleFileDelete = (fileUrl) => {
    setTribunalReview({
      ...tribunalReview,
      files: tribunalReview.files.filter((f) => f != fileUrl),
    });
  };

  const handleSelect = (e) => {
    setTribunalReview({
      ...tribunalReview,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditorChange = (content) => {
    setTribunalReview({
      ...tribunalReview,
      remarks: content,
    });
  };

  const handleDatePicker = (date, name) => {
    if (moment.isMoment(date)) {
      if (name === "requestedDate") {
        setTribunalReview({
          ...tribunalReview,
          [name]: date.format(DEFAULT_DATE_FORMAT).toString(),
          dueDate: date
            .clone()
            .add(27, "days")
            .format(DEFAULT_DATE_FORMAT)
            .toString(),
        });
      } else {
        setTribunalReview({
          ...tribunalReview,
          [name]: date.format(DEFAULT_DATE_FORMAT).toString(),
        });
      }
    } else {
      setTribunalReview({
        ...tribunalReview,
        [name]: date,
      });
    }
  };

  const dispatch = useDispatch();

  const saveError = useSelector(
    (state) => state.tribunalReview.tribunalReviewCreateError
  );
  const saveSuccess = useSelector(
    (state) => state.tribunalReview.tribunalReviewCreateSuccess
  );
  const saveProgress = useSelector(
    (state) => state.tribunalReview.tribunalReviewCreateFetching
  );

  function createTribunalReview() {
    const errors = isValidTribunalReviewInputs(tribunalReview);
    if (errors.length > 0) {
      setValidationErrorMsg(errors);
      dispatch({ type: CLEAR_ERROR });
    } else if (isDuplicateApplicant(tribunalReview, props.allTribunalReview)) {
      selectedEvent();
    } else {
      confirmTribunalReview();
    }
  }

  function confirmTribunalReview() {
    setValidationErrorMsg("");
    dispatch({
      type: TRIBUNAL_REVIEW_CREATE_REQUESTED,
      payload: tribunalReview,
    });
  }

  function clearErrors() {
    setValidationErrorMsg("");
  }

  useEffect(() => {
    setModalOpen(props.open);
  }, [props.open]);

  useEffect(() => {
    if (!modalOpen) {
      clearErrors();
      // setStudent({});
    }
  }, [modalOpen]);

  useEffect(() => {
    setValidationErrorMsg("");
    dispatch({ type: CLEAR_ERROR });
  }, []);

  useEffect(() => {
    setError(saveError);
  }, [saveError]);

  useEffect(() => {
    setSuccess(saveSuccess);
  }, [saveSuccess]);

  useEffect(() => {
    if (saveSuccess === true) {
      setTimeout(() => {
        props.handleSuccess(false);
      }, 700);
      dispatch({ type: TRIBUNAL_REVIEW_GET_ALL_REQUESTED });
      setTimeout(() => {
        setTribunalReview({});
        dispatch({ type: CLEAR_ERROR });
      }, 701);
    }
  }, [saveSuccess]);

  const classes = useStyles();
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardBody className="d-flex flex-column gap-3">
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  {validationErrorMsg && (
                    <SnackbarContent
                      message={validationErrorMsg}
                      color="warning"
                    />
                  )}
                  {error && (
                    <SnackbarContent message={errMessage} color="warning" />
                  )}
                  {saveProgress && <CustomLinearProgress color="primary" />}
                  {success && (
                    <SnackbarContent
                      message="Added the tribunal review"
                      color="success"
                    />
                  )}
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Email address *"
                    id="tribunal-review-add-email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tribunalReview.email || "",
                      onChange: handleSelect,
                      name: "email",
                      type: "email",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Phone Number *"
                    id="tribunal-review-add-phone"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tribunalReview.phone || "",
                      onChange: handleSelect,
                      name: "phone",
                    }}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="First Name *"
                    id="tribunal-review-add-firstName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tribunalReview.firstName || "",
                      onChange: handleSelect,
                      name: "firstName",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Middle Name"
                    id="tribunal-review-add-middleName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tribunalReview.middleName || "",
                      onChange: handleSelect,
                      name: "middleName",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Last Name *"
                    id="tribunal-review-add-lastName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tribunalReview.lastName || "",
                      onChange: handleSelect,
                      name: "lastName",
                    }}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <InputLabel className={classes.label}>
                    Date of Birth
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={tribunalReview.dob || ""}
                      onChange={(moment) => handleDatePicker(moment, "dob")}
                      inputProps={{
                        name: "dob",
                        id: "add-tribunal-review-dob-date",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <DropDownWithSearch
                    optionsList={getDropDown("country")}
                    selectedOption={tribunalReview.country || ""}
                    setValue={setTribunalReview}
                    currentState={tribunalReview}
                    name={"country"}
                    label={"Country"}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Passport No"
                    id="tribunal-review-add-passport"
                    type="number"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tribunalReview.passport,
                      onChange: handleSelect,
                      name: "passport",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <InputLabel className={classes.label}>
                    Passport Issue Date
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={tribunalReview.issueDate || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "issueDate")
                      }
                      inputProps={{
                        name: "issueDate",
                        id: "tribunal-review-add-issueDate",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <InputLabel className={classes.label}>
                    Passport Expiry Date
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={tribunalReview.expiryDate || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "expiryDate")
                      }
                      inputProps={{
                        name: "expiryDate",
                        id: "tribunal-review-add-expiryDate",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <FormControl fullWidth>
                    <div
                      className={classes.label}
                      style={labelStyleFunc(tribunalReview.occupation)}
                    >
                      Occupation
                    </div>
                    <ReactSelect
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable
                      isSearchable
                      value={
                        tribunalReview.occupation
                          ? {
                              label: tribunalReview.occupation,
                              value: tribunalReview.occupation,
                            }
                          : ""
                      }
                      styles={customReactSelectStyles}
                      options={occupationOption}
                      name="occupation"
                      placeholder={"Occupation"}
                      onChange={(options) => {
                        if (!options) {
                          setTribunalReview({
                            ...tribunalReview,
                            occupation: "",
                            anzsco: "",
                          });
                        } else {
                          setTribunalReview({
                            ...tribunalReview,
                            occupation: options.value,
                            anzsco: getAnzsco(options.value),
                          });
                        }
                      }}
                    />
                  </FormControl>
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                  <FormControl fullWidth>
                    <div
                      className={classes.label}
                      style={labelStyleFunc(tribunalReview.anzsco)}
                    >
                      ANZSCO
                    </div>
                    <ReactSelect
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable
                      isSearchable
                      value={
                        tribunalReview.anzsco
                          ? {
                              label: tribunalReview.anzsco,
                              value: tribunalReview.anzsco,
                            }
                          : ""
                      }
                      styles={customReactSelectStyles}
                      options={occupationCodeOption}
                      name="anzsco"
                      placeholder={"ANZSCO"}
                      onChange={(options) => {
                        if (!options) {
                          setTribunalReview({
                            ...tribunalReview,
                            anzsco: "",
                            occupation: "",
                          });
                        } else {
                          setTribunalReview({
                            ...tribunalReview,
                            anzsco: options.value,
                            occupation: getOccupation(options.value),
                          });
                        }
                      }}
                    />
                  </FormControl>
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                  <FormControl fullWidth>
                    <div
                      className={classes.label}
                      style={labelStyleFunc(tribunalReview.purposedVisa)}
                    >
                      Purposed Visa
                    </div>
                    <ReactSelect
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable
                      isSearchable
                      value={
                        tribunalReview.purposedVisa
                          ? {
                              label: tribunalReview.purposedVisa,
                              value: tribunalReview.purposedVisa,
                            }
                          : ""
                      }
                      styles={customReactSelectStyles}
                      options={visaTypeOption}
                      name="purposedVisa"
                      placeholder={"Purposed Visa"}
                      onChange={(options) => {
                        if (!options) {
                          setTribunalReview({
                            ...tribunalReview,
                            purposedVisa: "",
                          });
                        } else {
                          setTribunalReview({
                            ...tribunalReview,
                            purposedVisa: options.value,
                          });
                        }
                      }}
                    />
                  </FormControl>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <InputLabel className={classes.label}>
                    Visa Submitted Date
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={tribunalReview.submittedDate || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "submittedDate")
                      }
                      inputProps={{
                        name: "submittedDate",
                        id: "submittedDate-add2",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <InputLabel className={classes.label}>
                    Decision Date
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={tribunalReview.decisionDate || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "decisionDate")
                      }
                      inputProps={{
                        name: "decisionDate",
                        id: "decisionDate-add2",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  <InputLabel className={classes.label}>
                    Requested Date
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      autoOk
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={tribunalReview.requestedDate || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "requestedDate")
                      }
                      inputProps={{
                        name: "requestedDate",
                        id: "requestedDate-add",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <InputLabel className={classes.label}>Due Date</InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={tribunalReview.dueDate || ""}
                      onChange={(moment) => handleDatePicker(moment, "dueDate")}
                      inputProps={{
                        name: "dueDate",
                        id: "dueDate-add2",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Invoice Number"
                    id="add-tribunal-review-invoiceNumber"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tribunalReview.invoiceNumber || "",
                      onChange: handleSelect,
                      name: "invoiceNumber",
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Payment"
                    id="add-tribunal-review-payment"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tribunalReview.payment || "",
                      onChange: handleSelect,
                      name: "payment",
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  <DropDownWithSearch
                    optionsList={getDropDown("payment-status")}
                    selectedOption={tribunalReview.paymentStatus || ""}
                    setValue={setTribunalReview}
                    currentState={tribunalReview}
                    name={"paymentStatus"}
                    label={"Payment Status"}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={3}>
                  {props.allSources && (
                    <DropDownWithSearch
                      dbOptions={props.allSources}
                      selectedOption={tribunalReview.sourceId || ""}
                      setValue={setTribunalReview}
                      currentState={tribunalReview}
                      name={"sourceId"}
                      label={"Source"}
                    />
                  )}
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <DropDownWithSearch
                    optionsList={getDropDown("tribunal-review-csa-status")}
                    selectedOption={tribunalReview.csaStatus || ""}
                    setValue={setTribunalReview}
                    currentState={tribunalReview}
                    name={"csaStatus"}
                    label={"CSA Status"}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <DropDownWithSearch
                    optionsList={getDropDown("tribunal-review-status")}
                    selectedOption={tribunalReview.status || ""}
                    setValue={setTribunalReview}
                    currentState={tribunalReview}
                    name={"status"}
                    label={"Status *"}
                  />
                </GridItem>
                {tribunalReview.status &&
                  [
                    "Consulting",
                    "Follow-up",
                    " Collecting Docs",
                    " Cancelled",
                    " AAT Lodged",
                    "Info Requested",
                    "Info Provided",
                    " AAT Remitted",
                    "AAT Refused",
                    "Withdrawn",
                    "Ministerial Intervention",
                    " Ministerial Approved",
                    " Ministerial Refused",
                    " Judicial Review",
                    "Other",
                  ].includes(tribunalReview.status) && (
                    <GridItem xs={12} sm={12} md={4}>
                      <InputLabel className={classes.label}>
                        {tribunalReview.status} Date *
                      </InputLabel>

                      <FormControl fullWidth>
                        <Datetime
                          closeOnSelect
                          timeFormat={false}
                          dateFormat={DEFAULT_DATE_FORMAT}
                          value={tribunalReview.statusDate || ""}
                          onChange={(moment) =>
                            handleDatePicker(moment, "statusDate")
                          }
                          inputProps={{
                            name: "statusDate",
                            id: "add-tribunal-review-statusDate",
                            placeholder: DEFAULT_DATE_FORMAT,
                          }}
                        />
                      </FormControl>
                    </GridItem>
                  )}
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <InputLabel className={classes.label}>
                    Hearing Date
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={tribunalReview.hearingDate || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "hearingDate")
                      }
                      inputProps={{
                        name: "hearingDate",
                        id: "hearingDate-add2",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <InputLabel className={classes.label}>
                    Remainder Date
                  </InputLabel>

                  <FormControl fullWidth>
                    <Datetime
                      closeOnSelect
                      timeFormat={false}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      value={tribunalReview.hearingDate || ""}
                      onChange={(moment) =>
                        handleDatePicker(moment, "remainderDate")
                      }
                      inputProps={{
                        name: "remainderDate",
                        id: "remainderDate-add2",
                        placeholder: DEFAULT_DATE_FORMAT,
                      }}
                    />
                  </FormControl>
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                  {props.allUsers && (
                    <DropDownWithSearch
                      dbOptions={props.allUsers}
                      dbLabel={"firstName"}
                      selectedOption={tribunalReview.userId || ""}
                      setValue={setTribunalReview}
                      currentState={tribunalReview}
                      name={"userId"}
                      label={"Assigned To"}
                    />
                  )}
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <h4>Note:</h4>
                  <Editor
                    licenseKey={"gpl"}
                    tinymceScriptSrc={
                      "https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.1.2/tinymce.min.js"
                    }
                    value={tribunalReview.remarks || ""}
                    init={TINY_INIT}
                    onEditorChange={handleEditorChange}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem>
                  <div>
                    <h4>Documents:</h4>
                    <FileUpload
                      autoUpload
                      uploadOnly
                      label={"Upload new file"}
                      type={"tribunalReview"}
                      setFileUrl={(fileUrl) => handleFileUpload(fileUrl)}
                    />
                  </div>
                </GridItem>
              </GridContainer>
              <GridContainer>
                {tribunalReview.files &&
                  tribunalReview.files.length > 0 &&
                  tribunalReview.files.map((fileUrl, id) => {
                    return (
                      <GridItem key={id}>
                        <div
                          style={{
                            flexDirection: "column",
                            display: "flex",
                            backgroundColor: "#B0BEC5",
                            padding: "20px",
                            borderRadius: "25px",
                            marginTop: "10px",
                          }}
                        >
                          <FileUpload
                            fileUrl={fileUrl}
                            key={id}
                            handleDelete={(fileUrl) => {
                              handleFileDelete(fileUrl);
                            }}
                          />
                        </div>
                      </GridItem>
                    );
                  })}
              </GridContainer>
              <Button
                color="primary"
                className={classes.moveToRight}
                onClick={(e) => {
                  ReactGA.event({
                    category: "TribunalReview",
                    action: "Added a Tribunal Review profile",
                  });
                  e.preventDefault();
                  createTribunalReview();
                }}
              >
                Add
              </Button>
              {alert}
              <Clearfix />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
